export default __webpack_public_path__ + "static/media/cheerz-ee.abafe417.png";